import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getArtistById } from "../../api/artistApi";
import PageLoader from "../../components/pageLoader";
import Toast from "../../components/toast";
import ToastContainer from "../../components/toastContainer";

import CalendarTab from "./tabs/CalendarTab";
import BookingsTab from "./tabs/BookingsTab";
import FinancialTab from "./tabs/FinancialTab";
import DetailsTab from "./tabs/DetailsTab";
import CommunicationTab from "./tabs/CommunicationTab";
import TechnicalHospitalityTab from "./tabs/TechnicalTab";

const TABS = [
  { key: "calendar", label: "Calendar" },
  { key: "bookings", label: "Bookings" },
  { key: "financial", label: "Financial" },
  { key: "details", label: "Detail Page" },
  { key: "technical", label: "Technical & Hospitality" },
  { key: "communication", label: "Communication" },
];

const ArtistDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [artist, setArtist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("calendar");
  const [toast, setToast] = useState(null);

  const fetchArtist = async () => {
    try {
      setLoading(true);
      const data = await getArtistById(id);
      setArtist(data);
    } catch (err) {
      setToast({
        type: "error",
        message: err?.response?.data?.detail || "Failed to load artist",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArtist();
  }, [id]);

  if (loading) return <PageLoader />;

  if (!artist) {
    return (
      <div className="p-6 text-slate-400">
        Artist not found
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-slate-400 hover:text-white"
        >
          ← Back to Artists
        </button>

        {/* <button className="px-4 py-2 rounded-lg bg-pink-600 hover:bg-pink-700 text-white text-sm font-medium">
          Edit Artist
        </button> */}
      </div>

      {/* Artist Name */}
      <div>
        <h1 className="text-2xl font-semibold text-white">
          {artist.stage_name || "Artist"}
        </h1>
        <p className="text-sm text-slate-400">
          {artist.real_name || ""}
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-white/10 flex gap-6 overflow-x-auto">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`pb-3 text-sm font-medium transition whitespace-nowrap
              ${
                activeTab === tab.key
                  ? "text-pink-500 border-b-2 border-pink-500"
                  : "text-slate-400 hover:text-white"
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-slate-900/60 border border-white/10 rounded-xl">
        {activeTab === "calendar" && <CalendarTab artist={artist} />}
        {activeTab === "bookings" && <BookingsTab artist={artist} />}
        {activeTab === "financial" && <FinancialTab artist={artist} onRefreshArtist={fetchArtist} />}
        {activeTab === "details" && <DetailsTab artist={artist} onRefreshArtist={fetchArtist} />}
        {activeTab === "technical" && <TechnicalHospitalityTab artist={artist} onRefreshArtist={fetchArtist}/>}
        {activeTab === "communication" && <CommunicationTab artist={artist} />}
      </div>

      <ToastContainer>
        {toast && (
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(null)}
          />
        )}
      </ToastContainer>
    </div>
  );
};

export default ArtistDetailsPage;
